import { render, staticRenderFns } from "./CadastroAtalhos.vue?vue&type=template&id=731c0710&"
import script from "./CadastroAtalhos.vue?vue&type=script&lang=js&"
export * from "./CadastroAtalhos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports